import { createContext } from '@lit/context';
import { ProductOption } from '@repobit/dex-store';

export type optionContextType = Promise<ProductOption | null | undefined> | undefined
export const optionContext = createContext<optionContextType>(Symbol('option'));